// exportUtils.ts
import { utils, writeFile } from 'xlsx';

interface StudentData {
  fname: string;
  lname: string;
  course: string;
  batch: string;
  father: string;
  email: string;
  curAddress: string;
  perAddress: string;
  degree: string;
  comYear: string;
  university: string;
  cduration: string;
  joiningDate: string;
  endDate: string;
  isCompleted: string;
  isPlaced: string;
  _id: string;
}

interface FeeData {
  TotalFee: number;
  PaidFee: number;
}

export const exportStudentProfile = (student: StudentData, fee: FeeData) => {
  // Personal Information Section
  const personalInfo = [
    ['Student Profile'],
    ['Personal Information'],
    ['Full Name', `${student.fname} ${student.lname}`],
    ['Father Name', student.father],
    ['Email', student.email],
    ['Current Address', student.curAddress],
    ['Permanent Address', student.perAddress],
    [],
  ];

  // Fee Information Section
  const feeInfo = [
    ['Fee Details'],
    ['Total Fee', `₹${fee.TotalFee}`],
    ['Paid Fee', `₹${fee.PaidFee}`],
    ['Pending Fee', `₹${fee.TotalFee - fee.PaidFee}`],
    [],
  ];

  // Education Details Section
  const educationInfo = [
    ['Education Details'],
    ['Degree', student.degree],
    ['Year of Completion', student.comYear],
    ['University/College', student.university],
    [],
  ];

  // Course Information Section
  const courseInfo = [
    ['Course Information'],
    ['Course', student.course],
    ['Batch', student.batch],
    ['Course Duration', student.cduration],
    ['Joining Date', new Date(student.joiningDate).toLocaleDateString()],
    ['End Date', student.endDate || 'Not mentioned yet'],
    ['Course Status', student.isCompleted === 'No' ? 'In Progress' : 'Completed'],
    ['Placement Status', student.isPlaced === 'yes' ? 'Placed' : 'Not Placed'],
  ];

  // Combine all sections
  const exportData = [
    ...personalInfo,
    ...feeInfo,
    ...educationInfo,
    ...courseInfo,
  ];

  // Create workbook and worksheet
  const wb = utils.book_new();
  const ws = utils.aoa_to_sheet(exportData);

  // Set column widths
  ws['!cols'] = [
    { wch: 20 }, // First column (labels)
    { wch: 40 }, // Second column (values)
  ];

  // Add some style to headers
  if (ws['A1']) ws['A1'].s = { font: { bold: true, size: 14 } };
  if (ws['A2']) ws['A2'].s = { font: { bold: true } };
  if (ws['A9']) ws['A9'].s = { font: { bold: true } };
  if (ws['A14']) ws['A14'].s = { font: { bold: true } };
  if (ws['A19']) ws['A19'].s = { font: { bold: true } };

  // Add worksheet to workbook
  utils.book_append_sheet(wb, ws, 'Student Profile');

  // Generate filename using student name
  const filename = `${student.fname}_${student.lname}_Profile.xlsx`;

  // Export file
  writeFile(wb, filename);
};
